var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switcher-inner-wrapper",class:{'border': !_vm.noBorder}},[_c('div',{staticClass:"placeholder",class:_vm.type})])
}
var staticRenderFns = []

export { render, staticRenderFns }